import React from 'react';
import UrlLink from '../../../components/UI/UrlLink/UrlLink';
import classes from './HandlingUserData.module.css';
import paths from '../../../constants/paths';

import { QUERY_PARAM_DELETE_ACCOUNT } from '../../../containers/ContactUs/ContactUsContainer';

const da = (props) => (
  <div className={classes.Content}>
    {props.indexPage ? (
      <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}>
          <b>Eksportér data</b>
        </p>
        <p>
          For at downloade dine data, gå til den næste side
          <br />
          Indstillinger {'>'} Valgmuligheder {'>'} Datastyring {'>'} Eksportér
          data
        </p>
        <br />
        <div className={classes.HrLine} />
        <br />
      </div>
    ) : null}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}>
      <b>Anmod om sletning af data</b>
    </p>
    <br />
    <p> Følg nedenstående trin for at anmode om sletning af data: </p> <br />
    <p>
      1. Gå til siden{' '}
      <UrlLink
        to={`${
          props.indexPage ? paths.CONTACT_US : paths.SETTINGS__CONTACT_US
        }?${QUERY_PARAM_DELETE_ACCOUNT}`}
      >
        Kontakt os
      </UrlLink>
      <br />
      2. Vælg indstillingen "Slet konto og alle mine data" <br />
      3. Udfyld formularen og tryk på "Send besked" <br /> <br />
    </p>
  </div>
);

export default da;
